import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetVirtueFusionBonusBalance = () => {
    const send = useGenericSend();

    return useCallback(async (
        { vfToken, balanceType }: { vfToken: string; balanceType: string }
    ): Promise<{ bonus: Types.IVirtueFusionBonusBalance }> => {
        const { data } = await send<{ vfToken: string; balanceType: string }, { bonus: Types.IVirtueFusionBonusBalance }>({
            ID: 89503,
            description: 'Get Virtue Fusion balance',
            responses: [89504, 89522],
            vfToken,
            balanceType
        });

        return data;
    }, [send]);
};
